/* Novaris Pro PDP — variant picker, gallery, scroll rail, sticky ATC.
   Vanilla JS, no dependencies, safe to load once per page. */
(function () {
  'use strict';

  /* ---------------- gallery ---------------- */
  function initGallery(root) {
    var main = root.querySelector('[data-nv-main]');
    var btns = root.querySelectorAll('[data-nv-thumb]');
    if (!main || !btns.length) return;
    btns.forEach(function (b) {
      b.addEventListener('click', function () {
        var src = b.getAttribute('data-src');
        var srcset = b.getAttribute('data-srcset');
        if (src) main.src = src;
        if (srcset) main.srcset = srcset;
        btns.forEach(function (o) { o.setAttribute('aria-current', 'false'); });
        b.setAttribute('aria-current', 'true');
      });
    });
  }

  /* ---------------- variant picker + sticky ---------------- */
  function initBuy(root) {
    var form = root.querySelector('[data-nv-form]');
    if (!form) return;

    var priceEl = root.querySelector('[data-nv-price]');
    var wasEl = root.querySelector('[data-nv-was]');
    var badgeEl = root.querySelector('[data-nv-save]');
    var submit = form.querySelector('[data-nv-submit]');
    var radios = form.querySelectorAll('input[name="id"]');

    var stickyPrice = document.querySelector('[data-nv-sticky-price]');
    var stickyWas = document.querySelector('[data-nv-sticky-was]');
    var stickyBtn = document.querySelector('[data-nv-sticky-btn]');

    function selected() {
      for (var i = 0; i < radios.length; i++) if (radios[i].checked) return radios[i];
      return radios[0] || null;
    }

    function sync() {
      var r = selected();
      if (!r) return;
      var price = r.getAttribute('data-price');
      var was = r.getAttribute('data-compare');
      var save = r.getAttribute('data-save');
      var available = r.getAttribute('data-available') === 'true';

      if (priceEl && price) priceEl.textContent = price;
      if (wasEl) { wasEl.textContent = was || ''; wasEl.hidden = !was; }
      if (badgeEl) { badgeEl.textContent = save || ''; badgeEl.hidden = !save; }
      if (stickyPrice && price) stickyPrice.childNodes[0].nodeValue = price;
      if (stickyWas) { stickyWas.textContent = was ? ('reg. ' + was) : ''; }

      if (submit) {
        submit.disabled = !available;
        submit.textContent = available
          ? submit.getAttribute('data-label-available')
          : submit.getAttribute('data-label-soldout');
      }
    }

    radios.forEach(function (r) { r.addEventListener('change', sync); });
    sync();

    if (stickyBtn) {
      stickyBtn.addEventListener('click', function (e) {
        e.preventDefault();
        if (submit && submit.disabled) return;
        if (typeof form.requestSubmit === 'function') form.requestSubmit(submit);
        else form.submit();
      });
    }

    /* show sticky bar once the buy box has scrolled away (mobile only) */
    var sticky = document.querySelector('[data-nv-sticky]');
    if (sticky) {
      document.body.classList.add('nv-has-sticky');
      var anchor = root;
      var onScroll = function () {
        var rect = anchor.getBoundingClientRect();
        var past = rect.bottom < 40;
        var narrow = window.innerWidth <= 920;
        sticky.classList.toggle('is-on', past && narrow);
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
      onScroll();
    }
  }

  /* ---------------- four-sided loop rail ---------------- */
  function initLoop(root) {
    var items = [].slice.call(root.querySelectorAll('.nv-loopitem'));
    var fill = root.querySelector('.nv-rail-fill');
    if (!items.length || !fill) return;
    var lit = 0;
    if (!('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-lit'); });
      fill.style.height = '100%';
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-lit');
        io.unobserve(e.target);
        lit++;
        fill.style.height = Math.round((lit / items.length) * 100) + '%';
      });
    }, { rootMargin: '0px 0px -30% 0px', threshold: 0.15 });
    items.forEach(function (el) { io.observe(el); });
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-nv-gallery]').forEach(initGallery);
    (scope || document).querySelectorAll('[data-nv-buy]').forEach(initBuy);
    (scope || document).querySelectorAll('[data-nv-loop]').forEach(initLoop);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }

  /* re-init inside the theme editor when a section is re-rendered */
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
